import { ActionsUnion, createAction } from "common/reducers/UtilsTypes";
import { FenceRecord, IFenceData } from "common/records/Fence";

export const RECEIVE_FENCE = "@measurements_fences/RECEIVE_FENCE";
export const SET_FENCE = "@measurements_fences/SET_FENCE";
export const RESET_FENCE = "@measurements_fences/RESET_FENCE";
export const DELETE_FENCE = "@measurements_fences/DELETE_FENCE";
export const UPDATE_TOTALS = "@measurements_fences/UPDATE_TOTALS";

export const FenceActions = {
  receiveFence: (fence: Partial<IFenceData>) => createAction(RECEIVE_FENCE, { fence }),
  setFence: (fence: FenceRecord) => createAction(SET_FENCE, { fence }),
  resetFence: (fenceId: number) => createAction(RESET_FENCE, { fenceId }),
  deleteFence: (fenceId: number, cascade = true) => createAction(DELETE_FENCE, { fenceId, cascade }),
  updateTotals: (fenceId: number) => createAction(UPDATE_TOTALS, { fenceId }),
};

export type FenceActions = ActionsUnion<typeof FenceActions>;
